/**
 * Fields that must never reach the log.
 *
 * A change request row carries container objects and bookkeeping columns next to the real fields, and
 * neither belongs in a change log a lender user reads.
 * `lockedByActionId` is the clearest case: broker-service already treats a lock-only touch as "not a
 * real change" in SetTrackedEntityAudit, and the log has to agree. Which fields count as a change is
 * an open question on PMP-2013; this list is the demo's answer.
 */
export const EXCLUDED_FIELDS = new Set(['lockedByActionId', 'personalData', 'id', 'ohpenId', 'oldBrsId', 'oldFirmId', 'firmOhpenId']);
